/**
 * returns the URL without query string parameters for logging
 * i.e. https://advertising.amazon.com/ccx/ajax/advertisingApiCsrf?entityId -> https://advertising.amazon.com/ccx/ajax/advertisingApiCsrf
 * i.e. /ccx/ajax/advertisingApiCsrf?entityId -> https://advertising.amazon.com/ccx/ajax/advertisingApiCsrf
 * @param url string
 * @returns string
 */
export default (url: string): string => {
  // invalid url passed in - do not process
  if (!url.startsWith('/') && !url.startsWith('http')) {
    return url;
  }

  let modifiedUrl = url;

  // handle relative path
  if (url.startsWith('/')) {
    modifiedUrl = `${window.location.origin}${modifiedUrl}`;
  }

  const urlObject = new URL(modifiedUrl);
  return `${urlObject.origin}${urlObject.pathname}`;
};
